/**
 * GILAS — Anteprima immagine nel mega menu.
 * Al passaggio del mouse su un link del menu a tendina, mostra a destra
 * l'immagine della collezione/prodotto corrispondente (stile Dahlia).
 */
(function () {
  function showPreview(link) {
    var grid = link.closest('.mega-menu__grid');
    if (!grid) return;
    var preview = grid.querySelector('[data-gilas-preview-container]');
    if (!preview) return;
    var img = preview.querySelector('img');
    var src = link.getAttribute('data-gilas-preview');
    if (img.getAttribute('src') !== src) {
      img.src = src;
    }
    preview.hidden = false;
  }

  document.addEventListener('pointerover', function (e) {
    if (!(e.target instanceof Element)) return;
    var link = e.target.closest('.mega-menu__link[data-gilas-preview]');
    if (link) {
      showPreview(link);
      return;
    }
    // All'apertura del sottomenu, mostra l'immagine del primo link disponibile
    var submenu = e.target.closest('.menu-list__submenu');
    if (submenu) {
      var preview = submenu.querySelector('[data-gilas-preview-container]');
      if (preview && preview.hidden) {
        var first = submenu.querySelector('.mega-menu__link[data-gilas-preview]');
        if (first) showPreview(first);
      }
    }
  });
})();
